import View from "core/view";
import Scene, { SceneToWindowFitter } from "core/scene";
import { post } from "core/api";
import { makeTimeString } from "core/util";
let gameId = 0;
export default function GameView(element) {
  const view = View({
    element
  });
  const scene = new Scene("game-main");
  SceneToWindowFitter(scene);
  let currentLevel = null;
  function start(level) {
    currentLevel = level;
    currentLevel.telemetry = {
      id: gameId++,
      startTime: Date.now(),
      endTime: null
    };
    scene.start();
    setTimeout(() => {
      scene.focus();
      //scene.toast.show(level.name);
    }, 100);
  }
  function stop() {
    const {
      telemetry,
      player
    } = currentLevel;
    telemetry.endTime = Date.now();
    console.log("LEVEL stopped!", currentLevel);
    Object.assign(telemetry, {
      items: player.items,
      figure: player.figure,
      timeString: makeTimeString(telemetry.endTime - telemetry.startTime)
    });
    post("/telemetry", telemetry);
    scene.stop();
    currentLevel = null;
  }
  return Object.assign(view, {
    start,
    stop,
    scene
  });
}